import { ValidationResult } from './ValidationResult';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
export function hasValue(value: any): ValidationResult {
  return { isValid: value != undefined && value != null, errorMessages: [] };
}
